import { render, staticRenderFns } from "./StudentChatGraph.vue?vue&type=template&id=152bbca2&scoped=true&"
import script from "./StudentChatGraph.vue?vue&type=script&lang=js&"
export * from "./StudentChatGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152bbca2",
  null
  
)

export default component.exports